// API URL 환경 자동 감지
// 모든 API 서비스에서 공통으로 사용

const getApiBaseUrl = () => {
  // 1. 환경 변수가 설정되어 있으면 사용
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // 2. 로컬 개발 환경 감지 (localhost:3000에서 실행)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return "http://localhost:8080/api";
  }
  
  // 3. 배포 환경: 상대 경로 사용 (같은 도메인의 /api)
  return "/api";
};

export const API_BASE_URL = getApiBaseUrl();

